const config = require('../config'); const apiConfig = require('../api-config');
const keyBy = require('lodash/keyBy');
const find = require('lodash/find');
const pathResult = require('../resources/path-result');
const apiFactory = require('../resources/transactions/api-factory');
const serviceFactory = require('../resources/transactions/service-factory');
const parseRequestMetaData = require('../utils/parse-request-meta-data');


function parseJson(obj) {
  return JSON.stringify(obj);
}


function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/transactions/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match((`${p}transactions.fetchTx[{keys:fetchTxReq}][{keys:guidStr}]`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.fetchTx(req.params.fetchTxReq, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((`${p}transactions.cancelTx[{keys:input}][{keys:guidStr}]`), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.cancelTx(req.params.input, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      ))
    )

    .match((`${p}transactions.tradingCancelTx[{keys:input}][{keys:guidStr}]`), requests =>
    Promise.all(requests.map(({ req, res }) =>
      service.tradingCancelTx(req.params.input, req.params.metaData)
        .then(xs => res.value(xs))
        .catch(res.error)
    ))
  )

    .match(`${p}transactions.fetchWebTx[{keys:inputs}][{keys:guidStr}]`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.fetchWebTx(req.params.inputs, req.params.metaData)
          .then(r => res.value(r))
          .catch(res.error)
      ))
    )
    .match(`${p}transactions.rejectTx[{keys:inputs}][{keys:guidStr}]`, requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.rejectTx(req.params.inputs, req.params.metaData)
          .then(r => res.value(r))
          .catch(res.error)
      ))
    )
    .match((
      `${p}transactions.txRefresh[{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.txRefresh(req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((
      `${p}transactions.initializeTx[{keys:inputParam}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.initializeTx(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      ))
    )
    .match((
      `${p}transactions.generateTxChallenge[{keys:orderObj}][{keys:inputParam}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.generateTxChallenge(req.params.orderObj, req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      ))
    )
    .match((
      `${p}transactions.verifyChallengeResponse[{keys:inputParam}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.verifyChallengeResponse(req.params.inputParam, req.params.metaData)
          .then(response => res.value(response))
          .catch(res.error)
      ))
    );
}

module.exports = addRoutes;
